export default __webpack_public_path__ + "static/media/qc.78813f00.svg";